import React, { useEffect, useContext } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { useTranslation } from "react-i18next";

import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import { mobilePageContext } from "/src/App";
import { blobURL } from "common/StringUtils";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { LOCALES } from "common/constants";
import { getSchemaMarkup } from "common/FunctionUtils";

const AboutUs = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("om-invozio");
  const mobilepageContext = useContext(mobilePageContext);

  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const FskattBastianGroup2023 = `${blobURL}/F-skattInvozioLvSia.pdf`;
  const FörsäkringsbrevTryggHansa = `${blobURL}/Försäkringsbrev.pdf`;
  const TryggareInkassoiStockholmAB = `${blobURL}/TallyproAB.pdf`;
  const bankIntygDanskeBank = `https://invozioprod.blob.core.windows.net/files/bank-intyg-danske-bank.pdf?sp=r&st=2025-04-15T15:35:32Z&se=2050-04-14T23:35:32Z&spr=https&sv=2024-11-04&sr=b&sig=n%2BOW9Czia%2FyHgZqUz5t6LYmhlcP7smpcRPmH5HBLMCI%3D`;

  const downloadIcon = `${blobURL}/download.png`;
  const FirstAboutImg = `${blobURL}/lapimg.jpg`;
  const HistoryImg = `${blobURL}/mobile_view.jpg`;
  const visionImg = `${blobURL}/mobile_last.jpg`;
  const iphone = `${blobURL}/m3.png`;
  const user = useSelector((state) => state.auth.user);
  const language = localStorage.getItem("i18nextLng");

  return (
    <div>
      <Helmet>
        {schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        <title>{t("About us | Invozio - your partner in invoicing")}</title>
        <meta
          name="description"
          content={t(
            "Invozio is a leading supplier for self-employment. We offer security and flexibility for the self-employed in various industries."
          )}
        />
        {language === LOCALES.EN_US ? (
          <link rel="canonical" href="https://invozio.com/about-invozio" />
        ) : (
          <link rel="canonical" href="https://invozio.com/om-invozio" />
        )}
      </Helmet>

      {mobilepageContext === false &&
      location?.pathname === "/mobile_about_us" ? (
        ""
      ) : (
        <Header />
      )}

      <div className="home-page about_usfakts banner_about_us new_margin_header">
        <section className="banner about-banner">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-lg-6">
                <div className="left-content">
                  <h1 className="first">{t("About us")}</h1>
                  <h2 className="second">
                    {t("Invozio - Your partner in self-employment!")}
                  </h2>
                  <p>
                    {t(
                      "Welcome to Invozio, a rapidly growing platform for freelancers. We enable individuals to conduct business and invoice without starting their own company, through a simple, engaging, and secure platform. Our greatest strength lies in our competitive fee – only 1.9% on the invoiced amount, reflecting our commitment to offering the best prices in the market. We have created Sweden's most comprehensive platform, with many features and possibilities, such as creating consolidated invoices, sending RUT or ROT invoices, invoicing in English to foreign countries with the 10 major currencies, sending preliminary invoices before the originals, writing off VAT, sending quotes, or creating time reports with expense registration, and many more."
                    )}
                  </p>
                </div>

                {!user && (
                  <Button
                    className="mt-1 new_theme_btn "
                    onClick={() => {
                      navigate(
                        language === LOCALES.EN_US
                          ? `/emailregister?lang=${LOCALES.EN_US}`
                          : `/e-postregister?lang=${LOCALES.SV_SE}`
                      );
                      sessionStorage.setItem("accountType", 2);
                    }}
                  >
                    {t("Create Free Account")}
                  </Button>
                )}
              </div>

              <div className="col-md-6">
                <div className="right-content">
                  <img
                    src={FirstAboutImg}
                    alt="banner_image"
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="try new_try_sectn">
          <div className="container">
            <div className="row">
              <div className="col-md-4 mb-3 mb-md-3">
                <div className="card h-100 rounded-lg text-center">
                  <h4 className="font-weight-bold">#{t("Commitment")}</h4>
                  <p className="mb-0">
                    {t(
                      "We take full responsibility for you as a freelancer, demonstrating our commitment to your well-being and development. With us, you can concentrate on your work and grow professionally."
                    )}
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-3 mb-md-3">
                <div className="card h-100 rounded-lg text-center">
                  <h4 className="font-weight-bold">#{t("Efficiency")}</h4>
                  <p className="mb-0">
                    {t(
                      "As a freelancer, our service relieves you from handling payroll administration, accounting, annual reports, taxes, and corporate accounts. We take care of these administrative tasks, freeing up your time and enhancing your work capacity and efficiency."
                    )}
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-3 mb-md-3">
                <div className="card h-100 rounded-lg text-center">
                  <h4 className="font-weight-bold">#{t("Security")}</h4>
                  <p className="mb-0">
                    {t(
                      "We prioritize your safety and security as a user by offering a secure and reliable platform, protected with advanced cybersecurity and encryption. To ensure additional security, we manage all freelancers' funds in a client account at a Swedish big bank's facility, supervised by the Financial Supervisory Authority, and offer comprehensive insurance through Trygg Hansa for extra protection."
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="insight latest">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 mb-4 mb-md-0">
                <div className="left text-center">
                  <img
                    src={iphone}
                    alt="mobile_image"
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="col-md-6 mt-4 mt-md-0">
                <div className="left text-left">
                  <h2 className="security_about text-right">
                    {t("SECURITY FOR OUR USERS!")}
                  </h2>
                  <p className="about_herosec_txt">
                    {t(
                      "We value our customers and continuously strive to provide a secure and reliable platform. We understand the importance of trust and actively work on cybersecurity to protect your information, including encrypting all data exchanged between our devices. All freelancers' funds are managed in a client account at a Swedish big bank's facility, approved by the Swedish Financial Supervisory Authority, thanks to our partnership with TallyPro AB in Sweden AB.We also have a comprehensive insurance policy with Trygg Hansa, tailored for personnel leasing."
                    )}
                  </p>
                  <p className="about_herosec_txt mb-0">
                    {t(
                      "Our goal is for you to feel secure and confident in managing your own business. We are transparent in our operations and support you with the help and assistance you need."
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="foret">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-4">
                <h3 className="security_about">{t("COMPANY INFORMATION")}</h3>
              </div>

              <div className="col-lg-8">
                <div className="row">
                  <div className="col-md-6 mb-4 mb-md-0">
                    <div className="download-box h-100 shadow p-3">
                      <div className="inner-box d-flex align-items-center justify-content-between">
                        <div className="content d-block">
                          <p className="first mb-0">{t("F-Tax")}</p>
                          <a
                            className="how_calculate_link"
                            href={FskattBastianGroup2023}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <p className="second mb-0">{t("Download PDF")}</p>
                          </a>
                        </div>
                        <div className="image">
                          <a
                            href={FskattBastianGroup2023}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={downloadIcon}
                              alt="downlaod_icon"
                              loading="lazy"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-6">
                    <div className="download-box h-100 shadow p-3">
                      <div className="inner-box d-flex align-items-center justify-content-between">
                        <div className="content d-block">
                          <p className="first mb-0">
                            {t("AGREEMENT WITH SPP")}
                          </p>
                          <a
                            className="how_calculate_link"
                            href={SPPAvtalBastianGroup}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <p className="second mb-0">{t("Download PDF")}</p>
                          </a>
                        </div>
                        <div className="image">
                          <a
                            href={SPPAvtalBastianGroup}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={downloadIcon}
                              alt="downlaod_icon"
                              loading="lazy"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-6 mb-4 mb-md-0">
                    <div className="download-box h-100 shadow p-3">
                      <div className="inner-box d-flex align-items-center justify-content-between">
                        <div className="content d-block">
                          <p className="first mb-0">{t("Insurance letter")}</p>
                          <a
                            className="how_calculate_link"
                            href={FörsäkringsbrevTryggHansa}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <p className="second mb-0">{t("Download PDF")}</p>
                          </a>
                        </div>
                        <div className="image">
                          <a
                            href={FörsäkringsbrevTryggHansa}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={downloadIcon}
                              alt="downlaod_icon"
                              loading="lazy"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row second">
                  <div className="col-md-6">
                    <div className="download-box h-100 shadow p-3">
                      <div className="inner-box d-flex align-items-center justify-content-between">
                        <div className="content d-block">
                          <p className="first mb-0">
                            {t("AGREEMENT WITH TALLYPRO AB")}
                          </p>

                          <a
                            className="how_calculate_link"
                            href={TryggareInkassoiStockholmAB}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <p className="second mb-0">{t("Download PDF")}</p>
                          </a>
                        </div>
                        <div className="image">
                          <a
                            href={TryggareInkassoiStockholmAB}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={downloadIcon}
                              alt="downlaod_icon"
                              loading="lazy"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="download-box h-100 shadow p-3">
                      <div className="inner-box d-flex align-items-center justify-content-between">
                        <div className="content d-block">
                          <p className="first mb-0">
                            {t("BANK CERTIFICATE")}
                          </p>

                          <a
                            className="how_calculate_link"
                            href={bankIntygDanskeBank}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <p className="second mb-0">{t("Download PDF")}</p>
                          </a>
                        </div>
                        <div className="image">
                          <a
                            href={bankIntygDanskeBank}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={downloadIcon}
                              alt="downlaod_icon"
                              loading="lazy"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="historia">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="left">
                  <h2 className="security_about">{t("OUR HISTORY")}</h2>
                  <p className="first mb-0 pt-0">
                    {t(
                      "Invozio was founded in 2022 with the ambition to transform the way freelancers conduct business and invoice without owning a company. We identified a need for a flexible and cost-effective solution, marking the beginning of our journey. Our staffing agency has been operational since 2015, and our team has been working with consultants since 2008. We initially focused on hiring consultants with a niche in bringing labor from countries like Estonia and Latvia to Sweden, Norway, and Finland. We built the first version of our platform for our own consultants and opened it to the public on April 1, 2023."
                    )}
                  </p>
                </div>
              </div>
              <div className="col-md-6 mt-4 mt-md-0">
                <div className="image-box text-end">
                  <img
                    src={HistoryImg}
                    alt="work_banner"
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="vision">
          <div className="container">
            <div className="row align-items-center flex-column-reverse flex-md-row">
              <div className="col-md-6 mt-md-0">
                <div className="image-box">
                  <img
                    src={visionImg}
                    alt="vision_image"
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="col-md-6 mt-md-0">
                <div className="new_vision">
                  <h2 className="security_about text-right">
                    {t("OUR VISION")}
                  </h2>
                  <p className="first mb-0">
                    {t(
                      "We aim to be the leading platform in self-employment and invoicing without a company. We are dedicated to revolutionizing freelance work and creating a working environment that is flexible, secure, and rewarding."
                    )}
                  </p>
                  <p className="second mb-0">
                    {t(
                      "We continue to develop our services to meet the unique needs of freelancers globally. By being responsive to user feedback and continuously improving our platform, we aim to simplify the invoicing process and support freelancers on their path to success."
                    )}
                  </p>
                  <p className="third mb-0">
                    {t(
                      "We are committed to being a reliable partner by offering high security and trust, collaborating with trusted insurance companies and partners to provide additional protection and benefits to our users."
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="new_scts trustplot_sctn pb-0 about">
          <div className="container container-dynamic pb-0">
            <div
              className="trustpilot-widget"
              data-locale={LOCALES.SV_SE}
              data-template-id="5406e65db0d04a09e042d5fc"
              data-businessunit-id="64f712e3dbd20bbfcf3a825f"
              data-style-height="28px"
              data-style-width="100%"
              data-theme="light"
            >
              <a
                href="https://se.trustpilot.com/review/invozio.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Trustpilot
              </a>
            </div>
          </div>
        </section>
      </div>

      {mobilepageContext === false &&
      location?.pathname === "/mobile_about_us" ? (
        ""
      ) : (
        <Footer dashboardFooter={dashboardFooter} />
      )}
    </div>
  );
};

export default AboutUs;
